import { Spinner } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

export const RunSpinnerPane = () => {
  const { t } = useTranslation('contentTest');

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <Spinner size="lg" />
      <p className="text-base font-medium text-foreground">
        {t('contentTest.runSpinnerPane.runningContentTest')}
      </p>
    </div>
  );
};

RunSpinnerPane.displayName = 'RunSpinnerPane';
